import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=8933ae94&scoped=true&lang=pug&"
import script from "./Profile.vue?vue&type=script&lang=js&"
export * from "./Profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8933ae94",
  null
  
)

export default component.exports